import { SuggestionListItemProduct, SuggestionsList } from './suggestions-list';
import { getProductElementIndex } from './utils/get-element-index';
import React from 'react';
import { ProductSuggestion } from 'types/suggestions';
import { useSuggestionsButtonAction } from '../hooks/use-suggestions-button-action';
import { useTranslation } from 'react-i18next';

type ProductListProps = {
  showProducts: boolean;
  suggestionSelector: string;
  isDefaultList: boolean;
  slicedProducts: ProductSuggestion[];
  searchHref: string;
  index: number;
  buttonAction: ReturnType<typeof useSuggestionsButtonAction>;
  isSrp: boolean;
  showOnlyCategories: boolean;
};

export const ProductsList: React.FC<ProductListProps> = ({
  showProducts,
  suggestionSelector,
  slicedProducts,
  isDefaultList,
  index,
  isSrp,
  searchHref,
  buttonAction,
  showOnlyCategories,
}) => {
  const { t } = useTranslation();

  if (!showOnlyCategories && showProducts) {
    return (
      <SuggestionsList
        suggestionSelector={suggestionSelector}
        withTitle={false}
        withDivider={isDefaultList}
        title={t('header.searchbar.products')}
        aria-label={t('header.searchbar.products-aria')}
        data-qa={'product-suggestions'}
      >
        {slicedProducts.map((item, idx) => (
          <SuggestionListItemProduct
            productSuggestion={item}
            elementIndex={getProductElementIndex(idx, isDefaultList)}
            navigationIndex={index}
            searchHref={searchHref}
            buttonAction={buttonAction}
            isSrp={isSrp}
            suggestionSelector={suggestionSelector}
            key={item.phrase}
          />
        ))}
      </SuggestionsList>
    );
  } else {
    return null;
  }
};
